module.exports = __webpack_public_path__ + "static/media/average-rating.2ef50076.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/average-rating.png
// module id = 205
// module chunks = 0